let headerObserver = null;

function observeHeaderHeight() {
  if (headerObserver) return;

  const header = document.getElementById('header');
  if (!header) return;

  const setHeaderHeightVar = () => {
    document.documentElement.style.setProperty('--toast-header-height', `${header.offsetHeight}px`);
  };

  headerObserver = new ResizeObserver(setHeaderHeightVar);
  headerObserver.observe(header);

  setHeaderHeightVar();
}

export function getContainer() {
  const containerId = 'toast-container';
  let toastContainer = document.getElementById(containerId);

  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = containerId;
    toastContainer.className = 'toast-container';
    document.body.appendChild(toastContainer);
  }

  observeHeaderHeight();

  return toastContainer;
}

export function prefersReducedMotion() {
  return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
